import React, { useEffect, useState } from 'react';
import { RoutePath } from 'data';
import { ReduxState } from 'interface';
import { Spinner } from 'react-bootstrap';
import { connect, ConnectedProps } from 'react-redux';
import { NavLink, Route, useParams, Switch, Redirect } from 'react-router-dom';
import SLP from './SLP/SLP.index';
import './publishDetail.style.scss';
import AnswerDetail from './answerDetail/answerDetail.index';
import AnswerList from './answerList/answerList.index';
import EditAnswer from './editAnswer/editAnswer.index';
import { setPublishData } from 'redux/actions';
import { getDBPublish } from 'scripts/db';

const PublishDetail: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.publishDetail;
    const { publish, form } = useParams<any>();
    const [goback, setGoback] = useState(false);

    useEffect(() => {
        const temp = props.publishes?.find((item) => item.id === Number(publish));
        if (temp) props.dispatch(setPublishData(temp));
    }, [publish, props.publishes]);

    return (
        <div className="ucheck-kiosk-publish-detail">
            <div className="header">
                <i onClick={() => setGoback(true)} className="material-icons">
                    arrow_forward
                </i>
                <p className="header-text">{props.publishDetail?.title}</p>
            </div>
            {props.publishDetail ? (
                <>
                    <div className="title-button">
                        <NavLink activeClassName="active" to={RoutePath.dashboard.slp(publish, form)} className="items">
                            <div className="text">
                                <i className="material-icons">description</i>
                                {lang.questions}
                            </div>
                        </NavLink>
                        <NavLink
                            to={RoutePath.dashboard.answerList(publish, form)}
                            activeClassName="active"
                            className="items border"
                        >
                            <div className="text">
                                <i className="material-icons">description</i>
                                {lang.answers}
                            </div>
                        </NavLink>
                    </div>
                    <Switch>
                        <Route path={RoutePath.dashboard.answerList(':publish', ':form')}>
                            <AnswerList goback={goback} setGoback={() => setGoback(false)} />
                        </Route>
                        <Route path={RoutePath.dashboard.slp(':publish', ':form')}>
                            <SLP goback={goback} setGoback={() => setGoback(false)} />
                        </Route>
                        <Route path={RoutePath.dashboard.answerEdit(':publish', ':form', ':answer')}>
                            <EditAnswer goback={goback} setGoback={() => setGoback(false)} />
                        </Route>
                        <Route path={RoutePath.dashboard.answerDetail(':publish', ':form', ':answer')}>
                            <AnswerDetail goback={goback} setGoback={() => setGoback(false)} />
                        </Route>
                        <Route path="*">
                            <Redirect to={RoutePath.dashboard.answerList(publish, form)} />
                        </Route>
                    </Switch>
                </>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                    <Spinner style={{ zIndex: 1000 }} animation="border" variant="info" />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
    publishDetail: state.publishData,
    publishes: state.publishesData,
});

const connector = connect(mapStateToProps);
export default connector(PublishDetail);
